/* eslint-disable no-unused-vars */
// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import { wdConfigData } from "@/service/wd_app_config.js";

// util
import {
  insert_slide_byTemplateFile,
  generateImageUrl,
  getSlideImageOptions,
  shapeIsTextType,
} from "./gpt_addin_utils.js";

import { parseIndentedTextToTree, checkStringIncludeandCompareIntValue } from "./slide_data_utils.js";

import { insertImageByCompletionUrl } from "./gpt_image.js"
import { getTemplatePath, getTemplate, needMultiColumnTemplate,  getShapeContentSize } from "./template_utils.js";

const Office = window.Office;
var PowerPoint = window.PowerPoint;

// VSTO Host Object
import store from "@store";
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");

// 纯文字：标题页
export async function add_slide_title(slideData) {
  let templateUrl = `/layout/${getTemplatePath(slideData).title}/${getTemplate(store.get("gpt/template_contents_type").title, slideData, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await hostObject_slides.vsto_updateSlide_Title(index, JSON.stringify(slideData));
  } else {
    // 按照找到的类型来增加一页模板
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    // 按解析好的ppt内容，再更新模板中的对应内容
    await _update_slide_title(slideData);
  }
}

async function _update_slide_title(slideData) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation;
      let selectedSlides = presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];

      // 需要判断当前选中的slide是否是之前插入的模板那一页Slide，如果不是，则需要自动切换到选中那一页
      //#region
      let slides = presentation.slides;
      slides.load("items");
      await context.sync();
      let slidesItems = slides.items
      let newSlideIndex = 0
      let currentSlideExist = false

      selectedSlide.load('id')
      await context.sync()
      let currentSlideId = store.get("gpt/currentSlideId");
      if (currentSlideId) {
        if (currentSlideId !== selectedSlide.id) {
          // 如果当前选中的slide不是之前插入的模板那一页Slide，则需要自动切换到选中那一页
          for (let index = 0; index < slidesItems.length; index++) {
            const element = slidesItems[index];
            element.load('id')
            await context.sync()
            if (element.id === currentSlideId) {
              currentSlideExist = true
            }
          }
          if (currentSlideExist) {
            presentation.setSelectedSlides([currentSlideId]);
            await context.sync();
            
            selectedSlides = presentation.getSelectedSlides();
            selectedSlides.load("items");
            await context.sync();
            selectedSlide = selectedSlides.items[0];
          } else {
            // 如果没有找到之前插入的slide，则需要给用户提示，确认是否不小心删除了这一页PPT
            // currentSlideId = slidesItems[slidesItems.length - 1].id
            // store.set("gpt/currentSlideId", currentSlideId);
            // store.set("gpt/currentSlideIndex", slidesItems.length - 1);
            return
          }
        } else {
          // 如果当前选中的slide是之前插入的模板那一页Slide，则不需要切换
          currentSlideExist = true
        }
      } else {
        // 没有找到之前插入的slide，则需要给用户提示，确认是否不小心删除了这一页PPT
      }
      //#endregion

      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shapeIsTextType(shape.type, shape.name)) {
          let textFrame = shape.textFrame;
          textFrame.load("textRange");
          await context.sync();
          let textRange = textFrame.textRange;
          textRange.load("$all");
          await context.sync();
          if (shape.name.startsWith("Title") || shape.name.startsWith("标题") || shape.name.startsWith("文本") || shape.name.startsWith("Text") || shape.name.startsWith("Content")) {
            textRange.text = slideData.title;
            await context.sync();
          }
        }
      }
    });
  } catch (error) {
    console.log("_update_slide_title: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 小节页
export async function add_slide_section_header(slideData) {
  // 随机选取模版，插入模版
  let templateUrl = `/layout/${getTemplatePath(slideData).sectionHeader}/${getTemplate(store.get("gpt/template_contents_type").sectionHeader, slideData, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await hostObject_slides.vsto_updateSlide_Title(index, JSON.stringify(slideData));
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    // 更改模版中的内容
    await _update_slide_title(slideData);
  }
}

// 纯文字：标题+内容页
export async function add_slide_title_content(slideData) {
  // 随机选取模版，插入模版
  let templateUrl = `/layout/${getTemplatePath(slideData).titleContent}/${getTemplate(store.get("gpt/template_contents_type").titleContent, slideData, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await hostObject_slides.vsto_updateSlide_Title_Content(index, JSON.stringify(slideData));
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    // 更改模版中的内容
    await _update_slide_title_content(slideData);
  }
}

// 尾页
export async function add_slide_ending() {
  // 随机选取模版，插入模版
  let templateUrl = `/layout/${getTemplatePath(null).ending}/${getTemplate(store.get("gpt/template_contents_type").ending, null, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await hostObject_slides.vsto_updateSlide_Title_Content(index, JSON.stringify(""));
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
  }
}

async function _update_slide_title_content(slideData) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation;
      let selectedSlides = presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      
      // 需要判断当前选中的slide是否是之前插入的模板那一页Slide，如果不是，则需要自动切换到选中那一页
      //#region
      let slides = presentation.slides;
      slides.load("items");
      await context.sync();
      let slidesItems = slides.items
      let newSlideIndex = 0
      let currentSlideExist = false

      selectedSlide.load('id')
      await context.sync()
      let currentSlideId = store.get("gpt/currentSlideId");
      if (currentSlideId) {
        if (currentSlideId !== selectedSlide.id) {
          // 如果当前选中的slide不是之前插入的模板那一页Slide，则需要自动切换到选中那一页
          for (let index = 0; index < slidesItems.length; index++) {
            const element = slidesItems[index];
            element.load('id')
            await context.sync()
            if (element.id === currentSlideId) {
              currentSlideExist = true
            }
          }
          if (currentSlideExist) {
            presentation.setSelectedSlides([currentSlideId]);
            await context.sync();
            
            selectedSlides = presentation.getSelectedSlides();
            selectedSlides.load("items");
            await context.sync();
            selectedSlide = selectedSlides.items[0];
          } else {
            // 如果没有找到之前插入的slide，则需要给用户提示，确认是否不小心删除了这一页PPT
            // currentSlideId = slidesItems[slidesItems.length - 1].id
            // store.set("gpt/currentSlideId", currentSlideId);
            // store.set("gpt/currentSlideIndex", slidesItems.length - 1);
            return
          }
        } else {
          // 如果当前选中的slide是之前插入的模板那一页Slide，则不需要切换
          currentSlideExist = true
        }
      } else {
        // 没有找到之前插入的slide，则需要给用户提示，确认是否不小心删除了这一页PPT
      }
      //#endregion

      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shapeIsTextType(shape.type, shape.name)) {
          // shape text frame
          let textFrame = shape.textFrame;
          // text range
          textFrame.load("hasText")
          await context.sync()
          if (textFrame.hasText) {
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            // 增加判断是否是multi-column的内容
            if (needMultiColumnTemplate(slideData, false)) {
              if (shape.name.startsWith("Title") || shape.name.startsWith("标题")) {
                textRange.text = slideData.title;
                await context.sync();
              } else {
                let contentTreeObj = parseIndentedTextToTree(slideData.content)
                let columnTitleShapeNameTag = '号一级标题'
                let columnContentShapeNameTag = '号二级内容文本'
                if (shape.name.includes(columnTitleShapeNameTag)) {
                  for (let j = 0; j < contentTreeObj.length; j++) {
                    if (checkStringIncludeandCompareIntValue(shape.name, columnTitleShapeNameTag, j+1)) {
                      shape.load("height", "left", "top", "width")
                      await context.sync()
                      let size = getShapeContentSize(true, contentTreeObj.length)
                      // shape.height = 230
                      // shape.left = 66
                      // shape.top = 28.75  
                      shape.width = size.width
                      await context.sync()

                      textRange.text = contentTreeObj[j].content.replace(/\n$/, '');
                      await context.sync();
                    }
                  }
                } else if (shape.name.includes(columnContentShapeNameTag)) {
                  for (let j = 0; j < contentTreeObj.length; j++) {
                    let columnContentArr = contentTreeObj[j].children || [];
                    let columnContent = columnContentArr.map(item => item.content).join('\n');
                    if (checkStringIncludeandCompareIntValue(shape.name, columnContentShapeNameTag, j+1)) {
                      shape.load("height", "left", "top", "width")
                      await context.sync()
                      let size = getShapeContentSize(false, contentTreeObj.length)
                      shape.height = size.height
                      // shape.left = 66
                      // shape.top = 28.75
                      shape.width = size.width
                      await context.sync()

                      textFrame.load('autoSizeSetting')
                      await context.sync()
                      textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                      textRange.text = columnContent.replace(/\n$/, '');
                      await context.sync();
                    }
                  }
                } else if (shape.name.includes('动作按钮:')) {
                  // shape.load("height", "left", "top", "width")
                  // await context.sync()
                  // let size = getShapeContentSize(false, contentTreeObj.length)
                  // shape.height = size.height
                  // shape.left = 66
                  // shape.top = 28.75
                  // shape.width = size.width
                  // await context.sync()

                  // textFrame.load('autoSizeSetting')
                  // await context.sync()
                  // textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                  // textRange.text = 'Build With NextMind';
                  // await context.sync();
                }
              }
            } else {
              if (shape.name.startsWith("Title") || shape.name.startsWith("标题")) {
                textRange.text = slideData.title;
                await context.sync();
              } else if (
                shape.name.startsWith("Content") ||
                shape.name.startsWith("Text") ||
                shape.name.startsWith("内容") || 
                shape.name.startsWith("文本")
              ) {
                shape.load("height", "left", "top", "width")
                await context.sync()
                if (shape.height < 330) {
                  shape.height = 330
                }
                // shape.left = 66
                // shape.top = 28.75
                // shape.width = 828
                await context.sync()

                textFrame.load('autoSizeSetting')
                await context.sync()
                textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                textRange.load("paragraphFormat")
                await context.sync()
                let paragraphFormat = textRange.paragraphFormat
                paragraphFormat.load("bulletFormat")
                await context.sync()
                let bulletFormat = paragraphFormat.bulletFormat
                bulletFormat.load("visible")
                if (slideData.hasMaxLevel && slideData.hasMaxLevel > 1) {
                  bulletFormat.visible = false
                } else {
                  bulletFormat.visible = true
                }
                await context.sync()

                if (slideData.hasMaxLevel && slideData.hasMaxLevel > 1) {
                  textRange.text = slideData.content.replace(/\n$/, '');
                } else {
                  textRange.text = slideData.content.replace(/\n$/, '').replace(/ /g, '');
                }
                await context.sync();

                textRange.load("font", "size", "italic", "color", "bold")
                await context.sync()
          
                var textRangeTextFont = textRange.font
                if (textRangeTextFont.size < 16)  {
                  textRangeTextFont.size = 16
                } 
                // else {
                //   textRangeTextFont.size = 18
                // }
                await context.sync()
              } else if (shape.name.includes('动作按钮:')) {
                // shape.load("height", "left", "top", "width")
                // await context.sync()
                // let size = getShapeContentSize(false, contentTreeObj.length)
                // shape.height = size.height
                // shape.left = 66
                // shape.top = 28.75
                // shape.width = size.width
                // await context.sync()

                // textFrame.load('autoSizeSetting')
                // await context.sync()
                // textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                // textRange.text = 'Build With NextMind';
                // await context.sync();
              }
            }
          }
        }
      }
    });
  } catch (error) {
    console.log("_update_slide_title_content", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 带配图：标题页
export async function add_slide_title_image(slideData) {
  let templateUrl = `/layout/template_title/${getTemplate(store.get("gpt/template_contents_type").title, slideData, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(
      `${wdConfigData.baseURLTemplate}/${templateUrl}`
    );
    await hostObject_slides.vsto_updateSlide_Title(
      index,
      JSON.stringify(slideData)
    );
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await _update_slide_title(slideData);
  }

  // 生成ImageUrl
  let pptTopic = store.get("gpt/pptTopic");
  let inputImage =
    pptTopic.length > 0 ? pptTopic + ", " + slideData.title : slideData.title;
  // let imageUrl = "https://f7.baidu.com/it/u=2757647852,732655506&fm=222&app=106&size=f360,240&n=0&f=JPEG?s=C4DA7F8D087A07905D8C6DB303001003&sec=1683997200&t=6c57ec515528e3b894c24d831c8d43bf";
  let imageUrl = await generateImageUrl(inputImage);
  slideData.imageUrl = imageUrl;

  // 插入图片
  let options;
  if (vstoMode) {
    let strOptions = await hostObject_shapes.vsto_getSlideImageOptionsThenDel();
    options = JSON.parse(strOptions);
  } else {
    options = await getSlideImageOptions();
  }
  await insertImageByCompletionUrl(imageUrl, options);
}

// 带配图：标题+内容页
export async function add_slide_title_content_image(slideData) {
  let templateUrl = `/layout/template_title_contents/${getTemplate(store.get("gpt/template_contents_type").titleContent, slideData, false)}.pptx`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(
      `${wdConfigData.baseURLTemplate}/${templateUrl}`
    );
    await hostObject_slides.vsto_updateSlide_Title_Content(
      index,
      JSON.stringify(slideData)
    );
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await _update_slide_title_content(slideData);
  }

  // 生成图片
  let pptTopic = store.get("gpt/pptTopic");
  let inputImage =
    pptTopic.length > 0 ? pptTopic + ", " + slideData.title : slideData.title;
  // let imageUrl = "https://f7.baidu.com/it/u=2757647852,732655506&fm=222&app=106&size=f360,240&n=0&f=JPEG?s=C4DA7F8D087A07905D8C6DB303001003&sec=1683997200&t=6c57ec515528e3b894c24d831c8d43bf";
  let imageUrl = await generateImageUrl(inputImage);
  slideData.imageUrl = imageUrl;

  // 插入图片
  let options;
  if (vstoMode) {
    let strOptions = await hostObject_shapes.vsto_getSlideImageOptionsThenDel();
    options = JSON.parse(strOptions);
  } else {
    options = await getSlideImageOptions();
  }
  await insertImageByCompletionUrl(imageUrl, options);
}